import { render } from "./purchase_orders_index.vue?vue&type=template&id=6b178842&scoped=true"
import script from "./purchase_orders_index.vue?vue&type=script&lang=js"
export * from "./purchase_orders_index.vue?vue&type=script&lang=js"

import "./purchase_orders_index.vue?vue&type=style&index=0&id=6b178842&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b178842"]])

export default __exports__